export default __webpack_public_path__ + "static/media/empty-state.d459e9cf.svg";